import { Grid2 } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import StyledGridComp from "../../components/StyledGridComp";
import { fetchAllRolesServie } from "../../services/roleManagementService";
import { formatDate } from "../../utilities/helper";
import SearchedComponent from "../../components/SearchedComponent";
import useDebounceSearch from "../../hooks/useDebounceSearch";

const RoleManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [searchedValue, setSearchedValue] = useState("");

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getAllRoles(page, pageSize, access_token, debounceQuery);
    }
  }, [pageSize, page, debounceQuery]);

  useEffect(() => {
    if (role == "NonAdmin") {
      setHiddenColumns(["permissions", "subscriptions"]);
    }
  }, [role]);

  const columns = [
    {
      field: "shortName",
      headerName: "Name",
      width: 120,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.shortName;

        return <span className="data-font">{name}</span>;
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 220,
      renderHeader: () => <div className="grid-heading">{"Description"}</div>,
      renderCell: (params) => {
        const description = params.row.description;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/add-role-management", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {description}
          </button>
        );
      },
    },
    {
      field: "isBlinded",
      headerName: "Is Blinded",
      width: 100,
      renderHeader: () => <div className="grid-heading">{"Is Blinded"}</div>,
      renderCell: (params) => {
        const isBlinded = params.row.isBlinded;

        return (
          <span className="data-font">{!isBlinded ? "False" : "True"}</span>
        );
      },
    },
    {
      field: "lastUpdate",
      headerName: "Last Update",
      width: 150,
      renderHeader: () => <div className="grid-heading">{"Last Update"}</div>,
      renderCell: (params) => {
        const lastUpdate = params.row.lastUpdate;
        return <span className="data-font">{formatDate(lastUpdate)}</span>;
      },
    },
    {
      field: "dashboard",
      headerName: "Set Dashboard",
      renderHeader: () => <div className="grid-heading">{"Set Dashboard"}</div>,
      width: 150,
      renderCell: (params) => {
        const id = params.row.id;
        return <button className="grid-btn">Set Dashboard</button>;
      },
    },
    {
      field: "permissions",
      headerName: "Set Permissions",
      renderHeader: () => (
        <div className="grid-heading">{"Set Permissions"}</div>
      ),
      width: 150,
      renderCell: (params) => {
        const id = params.row.id;
        return (
          <button
            className="grid-btn"
            onClick={() => {
              navigate("/role-permissions", {
                state: {
                  id: id,
                },
              });
            }}
          >
            Set Permissions
          </button>
        );
      },
    },
    {
      field: "subscriptions",
      headerName: "Set Subscriptions",
      renderHeader: () => (
        <div className="grid-heading">{"Set Subscriptions"}</div>
      ),
      width: 180,
      renderCell: (params) => {
        const id = params.row.id;
        return (
          <button
            className="grid-btn"
            onClick={() => {
              navigate("/role-subscriptions", {
                state: {
                  id: id,
                },
              });
            }}
          >
            Set Subscriptions
          </button>
        );
      },
    },
    {
      field: "reports",
      headerName: "Set Reports",
      renderHeader: () => <div className="grid-heading">{"Set Reports"}</div>,
      width: 150,
      renderCell: (params) => {
        const id = params.row.id;
        return (
          <button
            className="grid-btn"
            onClick={() => {
              navigate("/role-reports", {
                state: {
                  id: id,
                },
              });
            }}
          >
            Set Reports
          </button>
        );
      },
    },
  ];

  const getAllRoles = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllRolesServie(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result?.data);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/role-management">
            Role Management
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Role Management</p>
          </Grid2>
          <Grid2 item md={6}>
            <SearchedComponent
              handleSearch={handleSearch}
              placeholder="Role"
              searchedValue={searchedValue}
            />
            {/* <button
                className="create-btn"
                onClick={() => navigate("/add-role-management")}
              >
                Add New Role
              </button> */}
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
            hidden={hiddenColumns}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default RoleManagement;
